@if (isTranslationLoaded()) {
  <cfp-portfolio-pdf-download-button
    [url]="url()"
    [fileName]="fileName()"
    [dataAnalytics]="dataAnalytics()"
    [buttonOutline]="buttonOutline()"
  >
    {{ downloadLabelKey() | translate }}
  </cfp-portfolio-pdf-download-button>
}
